import { v4 as uuidv4 } from 'uuid';

export function ModalActions() {
	return {
		componentName: 'ModalActions',
		componentId: uuidv4(),
		props: {
			isFullModeStyle: true,
			textPosition: 'left',
			imageUrl:
				'https://res.cloudinary.com/kentcdodds-com/image/upload/v1625032892/kentcdodds.com/content/blog/how-to-use-react-context-effectively/banner.jpg',
			headline: 'Promoções de Outono',
			subhead:
				'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Interdum mauris posuere fusce proin mattis. Hendrerit cras ut nunc enim dictum. Mattis proin ut quis donec sed eget nulla. Vel mi ut mauris integer.',
			callToActionText: 'Conferir',
			callToActionUrl: '/sale/d',
			callToActionMode: 'button',
			blockClass: 'banner-full-left',
			textAlignment: 'left',
		},
		childrenComponents: [],
	};
}

export function ModalActionsClose(props) {
	return {
		componentName: 'ModalActionsClose',
		componentId: uuidv4(),
		props: Object.assign(
			{
				label: 'Cancelar',
			},
			props,
		),
		childrenComponents: [],
	};
}
